import { ShieldAlert } from 'lucide-react'
import { Link } from 'react-router'

import { Button } from '@/components/ui/Button'
import { Card, CardContent } from '@/components/ui/Card'
import { PageHeader } from '@/components/layout/PageHeader'

/**
 * Vises i stedet for platformområdet, når kontoen har adgangen, men endnu
 * ikke tofaktor.
 *
 * Backend afviser hvert kald med sin egen fejltype, så dette er ikke
 * sikkerheden — det er vejvisningen. Uden den ville en nyudpeget
 * administrator møde en blank 403 uden at vide, hvad der manglede.
 */
export function TwoFactorGate() {
  return (
    <div className="mx-auto flex max-w-2xl flex-col gap-5">
      <PageHeader
        title="Platformadministration"
        description="Der mangler ét trin, før du kan komme ind."
      />

      <Card as="panel">
        <CardContent className="flex flex-col items-start gap-4">
          <span
            className="flex size-11 items-center justify-center rounded-full bg-warning-500/12 text-warning-300"
            aria-hidden="true"
          >
            <ShieldAlert className="size-5" />
          </span>

          <div>
            <h2 className="text-base font-semibold text-text-primary">
              Slå tofaktor til for at fortsætte
            </h2>
            <p className="mt-1 text-[13px] text-text-secondary">
              Herinde ligger alle kunders stamdata, licenser og brugere. Den adgang må ikke stå bag
              en adgangskode alene — mister du den, mister du dem alle sammen. Det tager et halvt
              minut med en authenticator-app på telefonen.
            </p>
          </div>

          <Button variant="primary" asChild>
            <Link to="/app/settings/security">Gå til Sikkerhed</Link>
          </Button>
        </CardContent>
      </Card>
    </div>
  )
}
